// extracted by mini-css-extract-plugin
module.exports = {"apps-list":"AppsList_apps-list__3Mk4h","alert":"AppsList_alert__1rRsu"};